<template>
  <project-page title="Commits">
    <template v-slot:default="{ project }">
      <commits :project="project" />
    </template>
  </project-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { alertController, modalController } from '@modus/ionic-vue'

import ProjectPage from '../common/ProjectPage'
import Commits from './Commits'

export default {
  components: {
    ProjectPage,
    Commits
  },
  data() {
    return {
      busy: true,
    }
  }
}
</script>

<style scoped>
.detail-page {
  height:100%;
}

.header {
  --padding-start:0;
  margin-bottom:20px;
}

ion-card-header ion-spinner {
  width:12px;
}
</style>
